// CorporateLoginPage.js
import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../utils/config';
import '../styles/login.css';
import logo from '../assets/logo.svg'

const Login = () => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
      setLoading(false);
    }
  };

  return (
    <div className="corporate-login-wrapper">
      <div className="corporate-login-container">
        <div className="login-left-panel">
          <div className="company-branding">
            <div className="company-logo">
                <img src={logo} width={70} height={70} alt="Logo" />
            </div>
            <h2 className="company-name">Aurigene</h2>
            <p className="company-tagline">
              PHARMACEUTICAL SERVICES
            </p>
          </div>
        </div>
        
        <div className="login-right-panel">
          <div className="login-form-container">
            <div className="login-header">
              <h1>Sign In</h1>
            </div>
            
            <div className="login-options">
              <button 
                className={`corporate-azure-btn ${loading ? 'loading' : ''}`}
                onClick={handleLogin}
                disabled={loading}
              >
                {loading ? (
                  <div className="btn-loading">
                    <div className="spinner"></div>
                    Signing in...
                  </div>
                ) : (
                  <>
                    <div className="btn-icon">
                      <svg viewBox="0 0 23 23">
                        <path fill="#f35325" d="M1 1h10v10H1z"/>
                        <path fill="#81bc06" d="M12 1h10v10H12z"/>
                        <path fill="#05a6f0" d="M1 12h10v10H1z"/>
                        <path fill="#ffba08" d="M12 12h10v10H12z"/>
                      </svg>
                    </div>
                    Sign in with Microsoft
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
